module.exports = __webpack_public_path__ + "img/logo-SINAPTISSSTE.bee16136.png";